export const modalFullTextInit = () => {
  if(document.querySelector('.read-more-trigger')) {
    document.addEventListener('click', (e) => {
      if(e.target.classList.contains('read-more-trigger')) {
        const modalTrigger = e.target;
        const modalTileParent = modalTrigger.closest('.tile-product');
        const modalText = modalTileParent.querySelector('.modal-full-text');

        console.log(modalText, 'modalText');

        modalText.style.display = 'block';
        document.body.classList.add('modal-open');
      }

      if((!e.target.closest('.modal-form__inner') && !e.target.matches('.read-more-trigger')) || e.target.matches('.modal-form__close')) {
        const modals = document.querySelectorAll('.modal-full-text');
        
        if(modals) {
          modals.forEach((modal) => {
            modal.style.display = 'none';
          });
        }

        document.body.classList.remove('modal-open');
      }
    });
  }
}